import {NgModule} from '@angular/core';
import {HTTP_INTERCEPTORS} from "@angular/common/http";
import {TokenRefreshInterceptor} from "../base/interceptors/token-refresh.interceptor";
import {LoginComponent} from "./components/login/login.component";
import {LogoutComponent} from "./components/logout/logout.component";
import {PreRegistrationComponent} from "./components/pre-registration/pre-registration.component";
import {ReactiveFormsModule} from "@angular/forms";
import {AuthRoute} from "./auth.route";

@NgModule({
  declarations: [
    LoginComponent,
    LogoutComponent,
    PreRegistrationComponent,
  ],
  imports: [
    AuthRoute,
    ReactiveFormsModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenRefreshInterceptor,
      multi: true
    }
  ]
})
export class AuthConfigModule {
}
